import { Utils } from 'utils';
import { RootState } from 'store/store';
import { IMeasurementValue } from 'types';
import { MeasurmentType } from 'constants/enums';

export const selectAllMeasurements = (store: RootState) =>
  store.measurements.list;

export const selectMeasurement =
  (type: keyof typeof MeasurmentType) => (store: RootState) =>
    store.measurements.list.find((item) => item.id === type)?.values ?? [];

export const selectMeasurements = (store: RootState) => {
  return store.measurements.list.reduce(
    (previus, current) => ({ ...previus, [current.id]: current.values }),
    {} as { [key in keyof typeof MeasurmentType]?: IMeasurementValue[] }
  );
};

export const selectMeasurementsAsOptions =
  (types: (keyof typeof MeasurmentType)[]) => (store: RootState) => {
    const measurements = selectMeasurements(store);

    const options = types.map((type) => {
      const values = measurements[type] ?? [];
      return Utils.Helpers.createSelectOptions(
        values.map((item) => item.value)
      );
    });

    return options;
  };
